import { getAssetPath} from '@stencil/core';
import i18n from 'roddeh-i18n';
import { toastController } from '@ionic/core';


export function functionalityNotInPoc(){
  launchToast('Funzionalità non implementata in fase di POC');
}

/**
 * Funzione per mostrare toast agli utenti
 * @param message (required) message to show 
 * @param color (optional) color of the toast background
 */
export async function launchToast(message, color?){
  const toast = await toastController.create({
    message: i18n(message),
    duration: 3000,
    position: 'top',
    color: color ? color : 'dark'
  });

  await toast.present();
}

export function changePage(page) {
    let router = document.querySelector('ion-router');
    router.push(page);   
} 

export function changePageRoot(page) {
  let router = document.querySelector('ion-router');
  router.push(page, 'root');   
}


/**
 * Check if all the required ion-input fields are validate
 * @param formid id of the form to check
 * @return true if all the fields are filled, false otherwise
 */
export function requiredFieldsFilled(formid) {
  let count = 0;
  let inputs = document.querySelectorAll('#' + formid + ' ion-input input[required]') as any;

  inputs.forEach((i) => {
    // If value not empty and it's valid
    if (i.value != '' && i.validity.valid == true) {
      count = ++count;
    }
  })

  if (count == inputs.length) {
    return true;
  } else {
    return false;
  }
}

/** Show password:
* @param pwd_ico icon to change
* @param pwd_input input
*/
export function showPassword(pwd_ico, pwd_input) {
  if (pwd_input.type === "password") {
    pwd_input.type = "text";
    pwd_ico.name = "eye-off-outline";
  } else {
    pwd_input.type = "password";
    pwd_ico.name = "eye-outline";
  }
}

/**
 * Prende in input la lingua da caricare, se non è disponibile allora carica la lingua di default.
 * @param defaultLang 
 * @param allLanguages 
 */
export function loadTranslation() {

  const browserLang: string = 'it'; // In caso di multilingua sarà da cambiare
  const supportedLanguages = ['it'];

  const files: string[] = ['words.json', 'be_messages.json'];

  const path: string = getAssetPath(`../../assets/translations/${browserLang}/`);
  const defaultPath: string = getAssetPath(`../../assets/translations/it/`);

  let requests: XMLHttpRequest[];

    // Se la lingua non è supportata, usa il percorso di default
  if (!supportedLanguages.includes(browserLang)) {
      requests = loadFiles(files, defaultPath);
  } else {
      requests = loadFiles(files, path);
  }


    // Verifica se tutte le richieste hanno avuto successo e i file sono validi
    const allValid: boolean = requests.every(req => req.status === 200 && req.responseText.trim() !== "");

    if (allValid) {
        // Aggiungi le traduzioni a i18n
        requests.forEach(req => {
            i18n.translator.add(JSON.parse(req.responseText));
        });
    }
}

/**
 * Carica i file di traduzione da un percorso specifico
 * Usata da: loadTranslation
 * @param files - Elenco dei file da caricare
 * @param basePath - Percorso base che contiene la lingua di riferimento
 * @returns Un array di XMLHttpRequest con le risposte delle richieste
 */
function loadFiles(files: string[], basePath: string): XMLHttpRequest[] {
    return files.map(file => {
        const request = new XMLHttpRequest();
        request.open("GET", getAssetPath(basePath + file), false);
        request.send(null);
        return request;
    });
}
